import React from "react";

class TaskFrequencyDataType extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.data.time_period ) {
      var { time_period, time_value } = this.props.data;
      if (time_period.includes("day")) {
        return <div>{I18n.t("daily") + " at " + time_value}</div>;
      } else if (time_period.includes("hour")) {
        return <div>{I18n.t("hourly")}</div>;
      }
    }
  }
}

export default TaskFrequencyDataType;
